import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ComponentRef, FrameworkDelegate, Mode} from '@ionic/core';
import {isNil} from 'lodash';
import {ClassOf, PropsOf} from 'src/app/domain/function/type.helper';

export interface ModalOptions<T> {
  component: ClassOf<T>;
  componentProps?: PropsOf<T>;
  presentingElement?: HTMLElement;
  showBackdrop?: boolean;
  backdropDismiss?: boolean;
  cssClass?: string | string[];
  delegate?: FrameworkDelegate;
  breakpoints?: number[];
  initialBreakpoint?: number;
  animated?: boolean;
  swipeToClose?: boolean;
  mode?: Mode;
  keyboardClose?: boolean;
  id?: string;
}

@Injectable({
  providedIn: 'root',
})
export class Modal {
  private modalElement: HTMLIonModalElement | null;

  constructor(private readonly modalCtrl: ModalController) {
  }

  async present<T>(options: ModalOptions<T>): Promise<HTMLIonModalElement> {
    this.modalElement = null;
    this.initializeDefaultOptions(options as any);

    const ionicModal = await this.modalCtrl.create(options as any);

    await ionicModal.present();

    ionicModal.querySelector(':scope > .ion-page')?.classList.add('ion-content-scroll-host');

    this.modalElement = ionicModal;

    const onDismiss = () => {
      this.modalElement.removeEventListener('willDismiss',onDismiss);
      this.modalElement = null;
    };

    this.modalElement.addEventListener('willDismiss', onDismiss);
    return ionicModal;
  }

  isOpen(): boolean {
    return !isNil(this.modalElement);
  }

  async dismiss(data?: any) {
    if (!this.isOpen()) {
      return;
    }

    try {
      await this.modalCtrl.dismiss(data);
    } catch (e) {
      this.modalElement = null;
    }
  }

  private initializeDefaultOptions(options: ModalOptions<ComponentRef>) {
    if (options.breakpoints === undefined) {
      options.breakpoints = [0.1, 0.5, 1];
    }
    if (options.cssClass === undefined) {
      options.cssClass = 'p-5 rounded bg-black-100';
    }
  }
}
